module.exports = __webpack_public_path__ + "img/monitorbox05.5e12b600.jpg";